import CommonService from "./common.service";

export const extractApiMessage = (err, fallback = "Request failed") =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

const LM_PREFIX = "/logistics-manager/invite-providers";

export async function fetchInviteLogisticsProviders(params = {}) {
  const res = await CommonService.get(`${LM_PREFIX}/search`, params, { silent: true });
  const data = res?.data?.data ?? res?.data ?? {};
  return {
    providers: Array.isArray(data.providers) ? data.providers : [],
    total: Math.trunc(Number(data.total) || 0),
    page: Math.max(1, Math.trunc(Number(data.page) || 1)),
    pageSize: Math.max(1, Math.trunc(Number(data.pageSize) || 20)),
  };
}

/** @deprecated use fetchInviteLogisticsProviders */
export async function searchInviteLogisticsProviders(q, params = {}) {
  const result = await fetchInviteLogisticsProviders({ q, ...params });
  return result.providers;
}

export async function getInviteLogisticsProvider(companyId) {
  const res = await CommonService.get(
    `${LM_PREFIX}/${encodeURIComponent(String(companyId))}`,
    {},
    { silent: true },
  );
  const body = res?.data?.data ?? res?.data;
  return body?.provider ?? null;
}

export async function assignLogisticsDedicatedServices(companyId, serviceTypes) {
  const res = await CommonService.post(`${LM_PREFIX}/assign`, {
    companyId,
    serviceTypes,
  });
  return res?.data?.data ?? res?.data ?? null;
}

export async function createAndInviteLogisticsProvider(payload) {
  const res = await CommonService.post(`${LM_PREFIX}/create-and-invite`, payload);
  const payloadData = res?.data ?? res;
  return {
    ...(typeof payloadData === "object" && payloadData ? payloadData : {}),
    message: res?.message,
  };
}

export async function checkInviteLogisticsProviderEmail(email) {
  const trimmed = String(email || "").trim();
  const res = await CommonService.get(
    `${LM_PREFIX}/check-email`,
    { email: trimmed },
    { silent: true },
  );
  return res?.data?.data ?? res?.data ?? null;
}
